import { InsertUpdatedSecurityValues } from "../../../store/types";
import { ISIN_IDX, NAME_IDX, QUOTE_FEED_IDX, ROW_ID_IDX } from "../../constants";

interface GetEditedSecurityDataArgs {
  rowValues: string[];
  quoteFeedID: string;
  relativeRow: number;
}

export const getEditedSecurityData = ({ rowValues, quoteFeedID, relativeRow }: GetEditedSecurityDataArgs) =>
  ({
    isin: rowValues[ISIN_IDX],
    securityProducerId: rowValues[ROW_ID_IDX],
    securityName: rowValues[NAME_IDX],
    quoteFeedName: rowValues[QUOTE_FEED_IDX],
    quoteFeedId: quoteFeedID,
    row: relativeRow,
  } as InsertUpdatedSecurityValues);
